import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';

const SeminarDateTime = (props) => {
  const {
    startDate,
    endDate,
    timeZone,
    asSpan,
  } = props;

  if (!startDate || !endDate) {
    return null;
  }

  const momentStart = moment.tz(startDate, timeZone);
  const sameDay = momentStart.isSame(endDate, 'day');
  const sameMonth = momentStart.isSame(endDate, 'month');
  const sameYear = momentStart.isSame(endDate, 'year');
  const momentEnd = moment.tz(endDate, timeZone);
  const Container = asSpan ? 'span' : 'div';

  if (sameDay) {
    const start = momentStart.format('MMMM D, YYYY');
    const end = `${momentStart.format('h:mm a')} - ${momentEnd.format('h:mm a')}`;

    if (asSpan) return <span>{start}, {end} ({timeZone})</span>;

    return (
      <div>
        <div>{start}</div>
        <div>{end}</div>
        <div>({timeZone})</div>
      </div>
    );
  }

  if (sameMonth) {
    const dt = `${momentStart.format('MMMM D')} - ${momentEnd.format('D, YYYY')}`;
    return <Container>{dt}</Container>;
  }

  if (sameYear) {
    const dt = `${momentStart.format('MMMM D')} - ${momentEnd.format('MMMM D, YYYY')}`;
    return <Container>{dt}</Container>;
  }

  const dt = `${momentStart.format('MMMM D, YYYY')} - ${momentEnd.format('MMMM D, YYYY')}`;
  return <Container>{dt}</Container>;
};

SeminarDateTime.propTypes = {
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  timeZone: PropTypes.string,
  asSpan: PropTypes.bool,
};

export default SeminarDateTime;
